const normaliseImgSrc = (src: string): string => {
  if (!src) return src;

  // If the Image URL is already absolute, return it as-is
  if (/^https?:\/\//i.test(src) || /^data:/i.test(src) || /^cid:/i.test(src))
    return src;

  // Some image urls from Seans API have the host embedded in the path:
  // e.g. /sites/process-builder.cosnetics.co.uk/assets/users/image.jpg => https://process-builder.cosnetics.co.uk/sites/process-builder.cosnetics.co.uk/assets/users/image.jpg
  if (src.startsWith('/sites/')) {
    const [, rest] = src.split('/sites/');
    const [host, ...path] = rest.split('/');

    if (host) {
      const sitePath = [host, ...path].join('/');
      return `https://${host}/sites/${sitePath}`;
    }
  }

  return src;
};

export const normaliseImagesInHtml = (html: string): string => {
  if (!html) return html;

  // replace all img src attributes with normalised src versions
  return html.replace(
    /(<img\b[^>]*\bsrc=["'])([^"']+)(["'][^>]*>)/gi,
    (_, openingImgTag, src, closingImgTag) => {
      // openingImgTag: img src=
      // src: /sites/process-builder.cosnetics.co.uk/assets/users/image.jpg
      // closingImgTag: "alt="image.jpg" width="150" height="132" border="0" />
      return `${openingImgTag}${normaliseImgSrc(src)}${closingImgTag}`;
    }
  );
};
